import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconAlertTriangle } from '@iwoca/icons';
import { AlertBox, Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';

import { BankSelection } from './BankSelection/BankSelection';
import { BankStatementUpload } from './BankStatementUpload/BankStatementUpload';
import { useStateKey } from '../../../../../../iwQueryClient/useStateKey';
import { maintainStateKey } from '../../../../../../iwRouter/LocationHelper';
import { useGetLinkedAccounts } from '../../../../../modals/BankSelectionModal/useGetLinkedAccounts';
import { useGetDocuments } from '../../../../../ui/documentRequirement/hooks/useGetDocuments';
import { InnerLayout } from '../../InnerLayout/InnerLayout';
import { useRequirementsProgress } from '../../useRequirementsProgress';

const BANK_STATEMENT_DOCUMENT_TYPE = 'bank statement';

export const LinkOpenBankingPage = () => {
    const history = useHistory();
    const { search } = useLocation();
    const [showError, setShowError] = useState(false);

    const linkedAccounts = useGetLinkedAccounts();
    const stateKey = useStateKey();
    const { data: documents } = useGetDocuments(stateKey);

    const hasBankStatements = documents?.data?.some(
        (document) =>
            // @ts-ignore — lapi-client types the array element as never
            document.attributes?.document_type === BANK_STATEMENT_DOCUMENT_TYPE
    );

    const progress = useRequirementsProgress();

    const handleConfirm = () => {
        if (linkedAccounts.length === 0 && !hasBankStatements) {
            setShowError(true);
            return;
        }
        tracking.ampli.fundingRequirementsBankVerificationCompleted({
            version: '2.0'
        });
        tracking.ampli.fundingRequirementCompleted({
            requirement: 'upload_bank_evidence',
            progress: { ...progress, upload_bank_evidence: true },
            version: '2.0'
        });
        history.push(
            maintainStateKey({ pathname: '/funding-requirements/', search })
        );
    };

    return (
        <InnerLayout
            title={
                <FormattedMessage
                    id="_.funding_requirements.link_open_banking.title"
                    defaultMessage="Verify your account"
                />
            }
            subheading={
                <FormattedMessage
                    id="_.funding_requirements.link_open_banking.subheading"
                    defaultMessage="Link your account in just a few clicks via Open Banking. Only your account number and name will be shared with us."
                />
            }
        >
            <div className="flex flex-col items-start gap-l">
                <BankSelection />
                <BankStatementUpload />

                {showError && (
                    <AlertBox
                        variant="failure"
                        className="flex items-center gap-m text-s text-core-40"
                    >
                        <IconAlertTriangle />
                        <FormattedMessage
                            id="_.funding_requirements.link_open_banking.validation_error"
                            defaultMessage="Please link your account or upload bank statements"
                        />
                    </AlertBox>
                )}

                <Button
                    variant="primary-rounded"
                    className="mt-l"
                    onClick={handleConfirm}
                >
                    <FormattedMessage
                        id="_.funding_requirements.link_open_banking.continue"
                        defaultMessage="Confirm and return to list"
                    />
                </Button>
            </div>
        </InnerLayout>
    );
};
